var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',[_vm._l((_vm.filters),function(filter,index){return [_c('FilterListItem',{key:index,attrs:{"filter":filter},on:{"filterSelected":_vm.selectFilter}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }